import { render, staticRenderFns } from "./Audios.vue?vue&type=template&id=3331a110&scoped=true&"
import script from "./Audios.vue?vue&type=script&lang=js&"
export * from "./Audios.vue?vue&type=script&lang=js&"
import style0 from "./Audios.vue?vue&type=style&index=0&id=3331a110&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3331a110",
  null
  
)

export default component.exports